<template>
    <div>
        <div class="white-box mt-3">
            <div class="data-group">
                <M3FormTitle title="Asumări" class="mb-4" :checked="true"></M3FormTitle>
                <div class="asumare">
                    <p class="purple-title">Atenție!</p>
                    <p class="desc-text">
                        Te rugăm să parcurgi cu atenție informațiile de mai jos. În conformitate cu cele descrise în proiect îți vei asuma îndeplinirea următorilor indicatori.
                        Îți recomandăm să analizezi cu atenție cifrele de mai jos și să îți dimensionezi proiectul în funcție de capacitatea administrativă a companiei.
                    </p>
                </div>
                <div class="asumare flex space-between items-center">
                    <div>
                        <p class="purple-title">LOCURI DE MUNCĂ ÎN ANUL 3 DE SUSTENABILITATE</p>
                        <p class="desc-text">
                            Ti-ai asumat prin proiect crearea de noi locuri de muncă sau menținerea numărului de locuri de muncă din anul 2019
                        </p>
                    </div>
                    <div>
                        <div class="right-info">
                            <span class="green-text">{{ locuriDeMunca }}</span>
                        </div>
                    </div>
                </div>
                <div class="asumare flex space-between items-center">
                    <div>
                        <p class="purple-title">CREȘTEREA PRODUCTIVITĂȚII MUNCII</p>
                        <p class="desc-text">
                            Ti-ai asumat prin proiect creșterea productivității muncii în anul 3 de sustenabilitate
                        </p>
                    </div>
                    <div>
                        <div class="right-info">
                            <span class="purple-text">{{ indicatorProductivitate }}%</span>
                        </div>
                    </div>
                </div>
                <div class="asumare">
                    <p class="purple-title">CREȘTEREA CIFREI DE AFACERI</p>
                    <p class="desc-text">
                        Prin cei doi indicatori de mai sus îți asumi creșterea cifrei de  afaceri conform următorului grafic
                    </p>
                </div>

                <div v-if="data2019 && data2020" class="asumari-group">
                    <div class="asumare-item active-item">
                        <p class="an"><strong>2019*</strong></p>
                        <p class="titlu">Cifra de afaceri</p>
                        <p class="numar">{{ formatPrice(data2019.cifraAfaceri) }} lei</p>

                        <p class="titlu">Număr de angajați</p>
                        <p class="numar">{{ data2019.numarAngajati }}</p>

                        <p class="titlu">Productivitatea muncii</p>
                        <p class="numar">
                            {{ formatPrice(workProductivity(2019)) }}&nbsp;
                            <span v-if="data2019.numarAngajati < 1">leu</span>
                            <span v-else>lei</span>
                        </p>
                        <p class="item-desc">*an de referință</p>
                    </div>
                    <div class="asumare-item">
                        <p class="an"><strong>2020</strong></p>
                        <p class="titlu">Cifra de afaceri</p>
                        <p class="numar">{{ formatPrice(data2020.cifraAfaceri) }} lei</p>

                        <p class="titlu">Număr de angajați</p>
                        <p class="numar">{{ data2020.numarAngajati }}</p>

                        <p class="titlu">Productivitatea muncii</p>
                        <p class="numar">
                            {{ formatPrice(workProductivity(2020)) }}&nbsp;
                            <span v-if="data2020.numarAngajati < 1 && data2020.numarAngajati !== 0">leu</span>
                            <span v-else>lei</span>
                        </p>
                    </div>
                    <div class="asumare-item">
                        <p class="an mb-0"><strong>2022</strong></p>
                        <p class="titlu-ani"><strong>Anul 1</strong> de implementare</p>

                        <p class="an mb-0"><strong>2023</strong></p>
                        <p class="titlu-ani"><strong>Anul 2</strong> de implementare</p>

                        <p class="an mb-0 green-text"><strong>2024</strong></p>
                        <p class="titlu-ani"><strong>Anul 1</strong> de sustenabilitate</p>

                        <p class="an mb-0 green-text"><strong>2025</strong></p>
                        <p class="titlu-ani"><strong>Anul 2</strong> de sustenabilitate</p>
                    </div>
                    <div class="asumare-item green-item">
                        <p class="an green-text"><strong>2026**</strong></p>
                        <p class="titlu">Cifra de afaceri <strong class="green-text">(asumată + {{ indicatorProductivitate }}%)</strong></p>
                        <p class="numar"><strong class="red-text">minim</strong> <strong class="green-text">{{ formatPrice(workProductivity(2026) * Number(this.locuriDeMunca)) }} lei</strong></p>

                        <p class="titlu">Număr de angajați</p>
                        <p class="numar"><strong class="red-text">minim</strong> <strong class="green-text">{{ Number(locuriDeMunca) }}</strong></p>

                        <p class="titlu">Productivitatea muncii</p>
                        <p class="numar">
                            > {{ formatPrice(workProductivity(2026)) }}&nbsp;
                            <span v-if="workProductivity(2026) == 1">leu</span>
                            <span v-else>lei</span>
                        </p>
                        <p class="item-desc green-text">**anul 3 de sustenabilitate</p>
                    </div>

                </div>
                <LoadingSpinner v-else style="min-height: 250px;"></LoadingSpinner>

                <div class="chart-asumare">
                    <p class="purple-title">Cifra de afaceri</p>
                    <apexchart type="area" height="350" :options="chartOptions" :series="getTurnoverChartData"></apexchart>
                </div>
                <div class="chart-asumare mt-5">
                    <p class="purple-title">Număr de angajați</p>
                    <apexchart type="area" height="350" :options="chartOptions2" :series="getEmployeesChartData"></apexchart>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import LoadingSpinner from '@/common/components/LoadingSpinner';
    import M3FormTitle from '../M3FormTitle'
    import Vue from 'vue'
    import VueApexCharts from 'vue-apexcharts'
    import api from '@/helpers/api'
    import axios from '@/helpers/axios'
    import _ from "lodash";
    Vue.use(VueApexCharts)
    Vue.component('apexchart', VueApexCharts)

    export default {
        name: 'AsumariContent',
        components: {
            LoadingSpinner,
            M3FormTitle
        },
        data() {
            return {
                data2019: null,
                data2020: null,
                data2022: null,
                data2026: null,
                indicatori: null,
                indicatorProductivitate: 21,
                locuriDeMunca: 0,
                chartOptions: {
                    colors: ['#ea8196'],
                    chart: {
                        height: 350,
                        type: 'date',
                        toolbar: {
                            show: false,
                        },
                    },
                    dataLabels: {
                        enabled: true,
                        formatter: function(value) {
                            var val = Math.abs(value)
                            if (val >= 1000) {
                                val = (val / 1000).toFixed(2) + ' K'
                            }
                            return val
                        }
                    },
                    stroke: {
                        curve: 'smooth'
                    },
                    xaxis: {
                        type: 'date',
                        categories: ["2019", "2020", "2026"]
                    },
                    tooltip: {
                        x: {
                            format: 'MM/yy'
                        },
                    },
                },
                chartOptions2: {
                    colors: ['#00e395'],
                    chart: {
                        height: 350,
                        type: 'date',
                        toolbar: {
                            show: false,
                        },
                        legend: {
                            show: true
                        },
                    },
                    dataLabels: {
                        enabled: true,
                    },
                    stroke: {
                        curve: 'smooth'
                    },
                    xaxis: {
                        type: 'date',
                        categories: ["2019", "2020", "2022", "2026"],
                    },
                    tooltip: {
                        x: {
                            format: 'dd/MM/yy HH:mm'
                        },
                    },
                },
            }
        },
        computed: {
            allData() {
                return this.$store.getters['m3Sketch/allData']
            },
            getEmployeesChartData() {
                return [{
                    name: 'Număr de angajați',
                    data: [Number(this.data2019 ? this.data2019.numarAngajati : 0), Number(this.data2020 ? this.data2020.numarAngajati : 0), Number(this.locuriDeMunca), Number(this.locuriDeMunca)]
                }]
            },
            getTurnoverChartData() {
                return [{
                    name: 'Cifra de afaceri',
                    data: [Number(this.data2019 ? this.data2019.cifraAfaceri : 0), Number(this.data2020 ? this.data2020.cifraAfaceri : 0), (Number(this.workProductivity(2026)) * Number(this.locuriDeMunca)).toFixed(2)]
                }]
            }
        },
        watch:{
            allData: {
                handler: function() {
                    if(this.allData && this.allData.m3_project && this.allData.m3_project.indicators){
                        this.indicatori = this.allData.m3_project.indicators
                        this.getIndicators()
                    }
                    this.getBusinessData()
                },
                deep: false
            }
        },
        mounted() {
            this.getIndicators()
            this.getBusinessData()
        },
        methods: {
            getIndicators() {
                this.indicatori = this.allData && this.allData.m3_project && this.allData.m3_project.indicators ? this.allData.m3_project.indicators : []
                this.indicatorProductivitate = (this.indicatori && this.indicatori.indicators && this.indicatori.indicators.supResult && _.filter(this.indicatori.indicators.supResult, v => v.title === "Productivitatea muncii în IMM-uri în anul 3 de sustenabilitate") && _.filter(this.indicatori.indicators.supResult, v => v.title === "Productivitatea muncii în IMM-uri în anul 3 de sustenabilitate").length &&  _.filter(this.indicatori.indicators.supResult, v => v.title === "Productivitatea muncii în IMM-uri în anul 3 de sustenabilitate")[0].number) ? _.filter(this.indicatori.indicators.supResult, v => v.title === "Productivitatea muncii în IMM-uri în anul 3 de sustenabilitate")[0].number : 21;
                this.locuriDeMunca = (this.indicatori && this.indicatori.indicators && this.indicatori.indicators.employees) ? this.indicatori.indicators.employees.number : 0;
            },
            getBusinessData() {
                axios.get(api.API_ENDPOINTS.m3 + JSON.parse(localStorage.getItem('currentM3Company')).business_id + '/v3')
                    .then(response => {
                        let bilant2019 = _.filter(response.data.bilant_scurt, v => v.an === 2019);
                        let bilant2020 = _.filter(response.data.bilant_scurt, v => v.an === 2020);
                        let indicators = null
                        if(this.allData && this.allData.m3_project && this.allData.m3_project.indicators && this.allData.m3_project.indicators.indicators)
                            indicators = this.allData.m3_project.indicators.indicators.employees.number2019
                        this.data2019 = {
                            cifraAfaceri: bilant2019[0] && bilant2019[0].cifra_de_afaceri_neta ? bilant2019[0].cifra_de_afaceri_neta : 0,
                            numarAngajati: !indicators ? bilant2019[0].numar_mediu_angajati : indicators
                        }
                        this.data2020 = {
                            cifraAfaceri: bilant2020[0] && bilant2020[0].cifra_de_afaceri_neta ? bilant2020[0].cifra_de_afaceri_neta : 0,
                            numarAngajati: bilant2020[0] && bilant2020[0].numar_mediu_angajati ? bilant2020[0].numar_mediu_angajati : 0
                        }
                    })
            },
            workProductivity(year){
                if(year === 2019){
                    if(this.data2019)
                        return this.data2019.numarAngajati > 0 ? (this.data2019.cifraAfaceri / this.data2019.numarAngajati).toFixed(2) : 0
                } else if(year === 2020){
                    if(this.data2020)
                        return this.data2020.numarAngajati > 0 ? (this.data2020.cifraAfaceri / this.data2020.numarAngajati).toFixed(2) : 0
                } else if(year === 2026){
                    return Number(this.locuriDeMunca) > 0 ? (((Number(this.locuriDeMunca) * this.workProductivity(2019)) + (this.indicatorProductivitate/100 * Number(this.locuriDeMunca) * this.workProductivity(2019))) / Number(this.locuriDeMunca)).toFixed(0) : 0
                }
            },
            formatPrice(price) {
                price = price.toString().replace('.', ',');
                var pattern = /(-?\d+)(\d{3})/;
                while (pattern.test(price))
                    price = price.replace(pattern, "$1.$2");
                return price;
            },
        }
    }
</script>

<style scoped>
.white-box {
    background: #fff;
    padding: 20px;
    position: relative;
}
.data-group{
    margin: auto;
    width: 90%;
}
.flex{
    display: flex;
}
.space-between{
    justify-content: space-between;
}
.items-center{
    align-items: center;
}
.purple-title{
    font-size: 18px;
    color: #846c88;
    font-weight: 600;
}
.desc-text{
    font-size: 13px;
    color: #778093;
}
.right-info{
    width: 35%;
    min-width: 150px;
    margin-left: 10px;
    background: #fff;
    border: 1px solid #d5d7da;
    border-radius: 2px;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    min-height: 60px;
}
.right-info span{
    font-size: 38px;
    line-height: 1;
    font-weight: 200;
}
.openedRightInfo{
    width: 35%;
    background: #fff;
    border: 1px solid #d5d7da;
    border-radius: 2px;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    min-height: 60px;
}
.openedRightInfo span{
    font-size: 38px;
    line-height: 1;
    font-weight: 200;
}
.green-text{
    color: #46cca6 !important;
}
.red-text{
    color: #f88c9b;
    font-size: 15px !important;
    margin-right: 5px;
}
.purple-text{
    color: #846c88;
}
.active-item{
    border-color: #846c88 !important;
}
.green-item{
    border-color: #46cca6 !important;
}
.asumare{
    margin-bottom: 35px;
}
.asumari-group{
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    margin-bottom: 85px;
    align-items: center;
	gap: 25px 0;
}
.asumare-item{
    width: 100%;
    max-width: 265px;
    padding: 15px;
    border: 1px solid #e6e6e6;
    border-radius: 6px;
    min-height: 283px;
    position: relative;
}
.item-desc{
    position: absolute;
    font-size: 12px;
    color: #846c88;
    bottom: -23px;
    left: 0;
}
.asumare-item .an{
    font-size: 21px;
    color: #846c88;
    text-align: center;
    margin-bottom: 15px;
}
.asumare-item .titlu{
    font-size: 12px;
    color: #778093;
    margin-top: 10px;
}
.asumare-item .titlu-ani{
    font-size: 12px;
    color: #778093;
    margin-bottom: 13px;
    text-align: center;
}
.asumare-item .numar{
    margin-bottom: 10px;
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    color: #846c88;
    padding: 5px 15px;
    border: 1px solid #e6e6e6;
}
.chart-asumare >>> .apexcharts-canvas {
    border: 1px solid #d1d1d1;
    border-radius: 10px;
    margin-top: 10px;
}
@media (max-width: 1600px) {
    .asumare-item{
        max-width: 24%;
    }
    .asumare-item .numar{
        font-size: 14px;
    }
}
</style>
